import { combineReducers } from "redux";

import flightSearch from "./components/search/reducer.js";
import userInfo from "./components/reducer.js";
import userAlerts from "./components/my_alerts/reducer.js";
import userActivity from "./components/activity_log/reducer.js";
import actions from "./components/actions.js";

const defaultState = {
  loading: null,
  result: null,
  error: null
};

const heightInfo = (state = defaultState, action) => {

  switch (action.type) {
    case actions.SET_WINDOW_HEIGHT:
      return Object.assign({}, state, {
        loading: false,
        result: action.payload,
        error: null
      });

    default:
      return state;
  }
};


const windowHeightInfo = (state = defaultState, action) => {

  switch (action.type) {
    case actions.SET_WINDOW_HEIGHT_FIXED:
      return Object.assign({}, state, {
        loading: false,
        result: action.payload,
        error: null
      });

    default:
      return state;
  }
};


const aboutPage = (state = defaultState, action) => {

  switch (action.type) {
    case actions.SET_ABOUT_SHOW:
      return Object.assign({}, state, {
        loading: true,
        result: null,
        error: null
      });
      case actions.SET_ABOUT_HIDE:
        return Object.assign({}, state, {
          loading: false,
          result: null,
          error: null
        });

    default:
      return state;
  }
};


const userAccount = (state = defaultState, action) => {

  switch (action.type) {
    case actions.SET_ACCOUNT_INFO:
      return Object.assign({}, state, {
        loading: true,
        result: action,
        error: null
      });
      case actions.SET_ACCOUNT_LOADING:
        return Object.assign({}, state, {
          loading: true,

        });
        case actions.SET_ACCOUNT_LOADING_OFF:
          return Object.assign({}, state, {
            loading: false,

          });


    default:
      return state;
  }
};







const rootReducer = combineReducers({
  flightSearch,
  userInfo,
  userAlerts,
  userActivity,
  userAccount,
  heightInfo,
  windowHeightInfo,
  aboutPage

});

export default rootReducer;
